import Location from 'yoda-core-components/lib/helpers/Location/Location';
import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

const loadVisitSToreToPurchase = (coords, payload) => {
    const data = `skuId=${payload.skuId}&radius=${payload.miles}&showAvailable=${payload.showAvailable}`;
    const params = `${data}&${coords}`;
    const config = {
        apiHost: apiHosts.browse,
        excludeVersion: true,
        url: `/browse-aggregator/v1/store-availability-service?${params}`,
    };
    return RestClient.get(config)
        .then((json) => json.data)
        .catch((error) => {
            console.error(`request failed ${error}`);
        });
};

const getCoords = async (payload) => new Promise((resolve, reject) => { // eslint-disable-line
        Location.getLatLong(
            (position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                const coords = `latitude=${pos.lat}&longitude=${pos.lng}`;
                loadVisitSToreToPurchase(coords, payload).then(resolve);
            },
            () => null
        );
    });

export const getVisitStoreToPurchaseByUrl = async (payload, latLng) => {
    let visitStoreToPurchase;
    if (Object.keys(latLng).length > 0) {
        visitStoreToPurchase = loadVisitSToreToPurchase(latLng, payload);
    } else {
        visitStoreToPurchase = await getCoords(payload);
    }
    return visitStoreToPurchase;
};
